import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TimesheetMeta } from 'contexts/timesheet-meta';

export interface TimesheetMetaSliceState {
  data: TimesheetMeta | null;
  error: null | string;
  loading: boolean;
}

const INITIAL_STATE: TimesheetMetaSliceState = {
  data: null,
  error: null,
  loading: false,
};

export const slice = createSlice({
  name: 'timesheetMeta',
  initialState: INITIAL_STATE,
  reducers: {
    set(state: TimesheetMetaSliceState, action: PayloadAction<TimesheetMeta>) {
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    },
  },
});
